// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1mJLP","container":"styles_container__3UD6z","title":"styles_title__3UYgv","wrapper":"styles_wrapper__3R54z","answer":"styles_answer__2rU2X"};